import { inject } from '@angular/core';
import { environment } from '@environments/environment';
import { INTERNAL_API_URL } from '@shared/utils';

export class ApiUrl {
  private readonly _baseUrl =
    inject(INTERNAL_API_URL, { optional: true }) || environment.backendUrl;

  get apiUrl(): string {
    return this._baseUrl;
  }
}
